// extracted by mini-css-extract-plugin
export default {"label":"UploadFile_label__A8SXm","container":"UploadFile_container__kxYIF"};